import cn from "classnames";

export const styles = {
  layout_container: cn(
    "hyam-layout-container pointer-events-none",
    "hyam-h-screen-visible",
    "hyam-full-width",
    "!fixed top-0 left-0",
    "z-50 opacity-0",
  ),
  container: cn(
    "hyam-layout",
    "flex-col hyam-h-screen-visible",
  ),

  top_container: cn(
    "flex relative",
    "items-center justify-between",
    "h-hyam-navbar-h-sm xl:h-hyam-navbar-h-xl",
    "flex-none",
    "mb-8 ",
  ),

  close_icon: cn(
    "cursor-pointer absolute left-0",
    "",
  ),

  logo_container: cn(
    // NOTE: setting the height of the whole nav bar on the logo container
    "lg:hidden relative h-hyam-navbar-h-sm xl:h-hyam-navbar-h-xl ml-[50%] -translate-x-1/2",
    "flex items-center",
    "w-fit px-6",
  ),
  logo: "h-5 xl:h-6",

  items_container: "",
  top_items_container: cn(
    "flex flex-col lg:fixed lg:top-1/2 lg:-translate-y-1/2",
    "landscape-mobile:gap-y-0 gap-y-6 lg:gap-y-2 ",
    "lg:pb-8",
  ),

  // middle_items_container: cn(
  //   "flex flex-col",
  //   "py-8",
  // ),
  bottom_items_container: cn(
    "flex flex-col fixed bottom-10",
    "pt-8",
  ),

  link: cn(
    "hyam-text-small mb-0 pointer-events-none uppercase",
    "mb-0",
    "decoration-transparent hover:decoration-hyam-black",
    "underline underline-offset-4 decoration-2",
    "hyam-animate-text",
  ),

  link_active:
    "underline underline-offset-4 decoration-2 decoration-hyam-black font-medium",

  button: "mb-28 hidden lg:flex",
};

export type HyamPrismicDocumentNavBar_DrawerStyles =
  typeof styles;

export const constants = {
  logoHeight: 24,
};
